import * as React from 'react'

import { cn } from '../../lib/utils'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'ring-offset-background flex h-11 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-shuttle-red focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:rounded-none',
          'dark:border-kinetic-outline-variant/30 dark:bg-kinetic-surface-container-highest dark:text-kinetic-on-surface dark:placeholder:text-kinetic-outline dark:focus-visible:ring-kinetic-primary-container dark:focus-visible:ring-offset-0',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
